import React from "react";
import {
	Grid,
	Box
} from "@mui/material";
import DownloadATemplatePanel from "./views/DownloadATemplatePanel";
import UploadATemplatePanel from "./views/UploadATemplatePanel";
import SellerDependentView from "../Shared/SellerDependentView";
import PermissionDependentView from "../Shared/PermissionDependentView/PermissionDependentView";
import { BreadCrumb } from "../Shared/BreadCrumb/BreadCrumb";

export default function ProductUpload({ seller, userdata }) {

	return (
		<Box id="product-upload">
			<PermissionDependentView userdata={userdata} permission="create_product">
				<SellerDependentView seller={seller}>
					<Grid container>
						<Grid item xs={12} lg={12} mb={4}>
							<BreadCrumb
								breadcrumbs={[
									{ label: "Inventory", url: "/inventory" },
									{ label: "Product Upload" }
								]}
							/>
						</Grid>
						<Grid item xs={12} lg={12} mb={4}>
							<DownloadATemplatePanel seller={seller} />
						</Grid>
						<Grid item xs={12} lg={12}>
							<UploadATemplatePanel seller={seller} />
						</Grid>
					</Grid>
				</SellerDependentView>
			</PermissionDependentView>
		</Box>
	);
}
